export default __webpack_public_path__ + "static/media/penis.43e30f81.svg";